// extracted by mini-css-extract-plugin
export default {"crazyDealsCroutonText":"zvedOe","crazyDealsCroutonIcon":"NGPeqy","crazyDealsCroutonBtn":"EK9VMd"};